var map = {
	"./workcase6Other1.jpg": 4378,
	"./workcase6Other2.jpg": 4277,
	"./workcase6Other3.jpg": 6408,
	"./workcase6Other4.jpg": 6203,
	"./workcase6Other5.jpg": 8158,
	"./workcase6Other6.jpg": 5273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2631;